module.exports = __webpack_public_path__ + "img/cooperation10.cd4f90f4.png";